import React from "react";
import {
  Container,
  Typography,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GraphicalAbstract from "./GraphicalAbstract";
import { isMobile } from "react-device-detect";

export default function IntroductionAccordion({ ...props }) {
  const [open, setOpen] = React.useState(false);
  return (
    <Container
      maxWidth="md"
      disableGutters
      sx={{
        paddingTop: { xs: 0, lg: 1 },
        flex: "0 1 auto",
        marginTop: 2,
        marginBottom: 2,
      }}
      {...props}
    >
      <Box sx={{ px: 2, padding: 0 }}>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="bold">About this study</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ marginBottom: 2 }}>
              This website shows data from a study on clinical trials reporting
              in the Nordic countries, led by Cathrine Axfors and Gustav
              Nilsonne. Shown here are the proportion of trials registered in
              the EU Clinical Trials Registry (EUCTR) or clinicaltrials.gov that
              reported results, either in the registry or in an academic
              publication. For details, please see our{" "}
              <Link href="https://doi.org/10.1016/j.jclinepi.2025.111710">
                article
              </Link>
              ,{" "}
              <Link
                onClick={(e) => {
                  if (isMobile) {
                    return;
                  } else {
                    e.preventDefault();
                    setOpen(true);
                  }
                }}
                href="GA_v1.3.jpg"
                sx={{ cursor: "pointer" }}
              >
                graphical abstract
              </Link>
              , or{" "}
              <Link href="https://www.medrxiv.org/content/10.1101/2024.02.04.24301363v1">
                preprint
              </Link>
              . For a commentary on the study in Swedish, please see our{"  "}
              <Link href="https://lakartidningen.se/klinik-och-vetenskap-1/kommentar/2024/06/registrering-och-rapportering-av-kliniska-studier-kan-bli-battre/">
                article
              </Link>{" "}
              in Läkartidningen.
            </Typography>
            <GraphicalAbstract open={open} handleClose={() => setOpen(false)} />
            <Typography sx={{ marginBottom: 2 }}>
              In this cross-sectional study, we included trials registered in
              the EU Clinical Trials Registry and/or ClinicalTrials.gov,
              completed 2016-2019, and led by a university with medical faculty
              or university hospital in Denmark, Finland, Iceland, Norway, or
              Sweden. We identified summary results posted at the trial
              registries, and conducted systematic manual searches for results
              publications (e.g., journal articles, preprints).
            </Typography>
            <Typography sx={{ marginBottom: 2 }}>
              Results can be filtered by time of reporting from study completion
              date (planned or actual), by whether results were reported in the
              registries or only in academic papers/abstracts, by country, by
              whether the study was a multicenter study, by the number of
              patients enrolled, and by phase (for pharmaceutical trials).
            </Typography>
            <Typography sx={{ marginBottom: 2 }}>
              Code for analyses was written by Cathrine Axfors and can be found{" "}
              <Link href="https://github.com/cathrineaxfors/nordic-trial-reporting">
                here
              </Link>
              . The dataset can be found{" "}
              <Link href="https://zenodo.org/records/10091147">here</Link>. The
              source code for this webpage was written by Love Ahnström and can
              be found{" "}
              <Link href="https://github.com/lahnstrom/vis-nordic">here</Link>.
              This project builds on work by the IntoValue project of the QUEST
              Center for Responsible Research in Berlin:{" "}
              <Link href="https://s-quest.bihealth.org/intovalue/">
                IntoValue dashboard
              </Link>{" "}
              and{" "}
              <Link href="https://quest-cttd.bihealth.org/">
                dashboard for clinical transparency
              </Link>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
}
